import React from 'react'
import { useLazyLoadQuery, graphql } from 'react-relay/hooks'
import { useParams } from 'react-router-dom'
import { useQueryParams } from 'hooks'
import ReportContent from '../ReportContent'
import { standardColumns } from '../../constants'
import { ReportSection } from '../../types'

type Props = {
  report: any
  reportSection: ReportSection
}

export default function TransactionDrilldown(props: Props) {
  const { report, reportSection } = props
  const { reportId } = useParams<Record<string, any>>()
  const { params: queryParams } = useQueryParams()

  const reportPeriod = queryParams?.startDate
    ? { startDate: queryParams.startDate, endDate: queryParams?.endDate }
    : null

  const transactionProps = queryParams?.accountId ? { accountId: queryParams.accountId } : null

  const data: any = useLazyLoadQuery(
    graphql`
      query TransactionDrilldownQuery(
        $reportId: ID!
        $reportPeriod: ReportPeriod
        $transactionProps: JSON
      ) {
        reportById(id: $reportId) {
          generalLedgerTransactions(
            input: { reportPeriod: $reportPeriod, transactionProps: $transactionProps }
          )
        }
      }
    `,
    { reportId, reportPeriod, transactionProps },
  )

  if (!data) {
    return null
  }

  const dataSections = [
    {
      data: data.reportById?.generalLedgerTransactions,
      columns: standardColumns,
      table: true,
      tableOptions: {
        emptyMessage: 'No transactions to display.',
      },
    },
  ]

  return (
    <ReportContent
      report={report}
      reportSection={{
        ...reportSection,
        dataSections,
      }}
    />
  )
}
